export default "__VITE_ASSET__Tarp1jPH__"